<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">Home</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">News</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{typeName}}</div>
                </div>
            </div>
            <div class="mobiletopbox_bottom" :class="isShowType?'mobiletopbox_bottom_active':''">
                <div class="mobile_type section">
                    <div class="mobile_type_text">
                        <div class="mobile_type_text_left" @click="handleShowType">Category</div>
                        <div class="mobile_type_text_right">
                            <img src="../assets/images/common/more.png" alt="">
                        </div>
                    </div>
                    <div class="mobile_type_box" v-if="isShowType">
                        <div class="mobile_type_box_item" 
                           @click="handleChangeType(item.id)"
                           :class="typeId==item.id?'mobile_type_box_item_active':''"
                           v-for="(item,i) in typeList" :key="i">
                           <div class="mobile_type_box_item_left"></div>
                           <div class="mobile_type_box_item_right">{{item.typeName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_left hidden-xs-only">
                <div class="news_left_box">
                    <div class="news_left_item"
                    @click="handleChangeType(item.id)"
                    :class="typeId==item.id?'news_left_item_active':''"
                    v-for="(item,i) in typeList" :key="i">
                        <div class="news_left_item_left">{{item.typeName}}</div>
                        <div class="news_left_item_right">
                            <img v-if="typeId==item.id" src="../assets/images/news/rightArrow_active.png" alt="">
                            <img v-else src="../assets/images/news/rightArrow.png" alt="">
                        </div>
                        <div class="news_left_item_line">
                            <img v-if="typeId==item.id" src="../assets/images/news/line_active.png" alt="">
                            <img v-else src="../assets/images/news/line_none.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="news_left_line">
                    <img src="../assets/images/news/news_left.png" alt="">
                </div>
            </div>
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">Location：</div>
                        <div class="navigation_index" @click="goIndex">Home</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">News</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">{{typeName}}</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box" v-if="newsList.length>0">
                        <div class="news_right_bottom_item" @click="linkToDetails(item)" v-for="(item,index) in newsList" :key="index">
                            <div class="news_right_bottom_item_left">
                                <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                <!-- <img class="none_img" v-else src="../assets/images/index/img_none_english.png" alt=""> -->
                                <div class="none_img_box" v-else>
                                    <img class="none_img" v-if="item.typeName=='Alliance Activities'" src="../assets/images/otherImg/other_11.png" alt="">
                                    <img class="none_img" v-if="item.typeName=='Industry News'" src="../assets/images/otherImg/other_22.png" alt="">
                                    <img class="none_img" v-if="item.typeName=='Notice'" src="../assets/images/otherImg/other_33.png" alt="">
                                </div>
                            </div>
                            <div class="news_right_bottom_item_right">
                                <div class="news_right_bottom_item_right_top">{{item.title}}</div>
                                <div class="news_right_bottom_item_right_time">PublishTime：{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                <div class="news_right_bottom_item_right_profile">{{item.profile}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom_none" v-if="newsList.length == 0">No data available</div>
                    <!-- 分页 -->
                    <el-pagination
                        :current-page="query.current"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange"
                        background
                        :total="total"
                        :pager-count="5"
                        layout="prev, pager, next">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsTypeList, newsList } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            typeId: this.$route.query.type?this.$route.query.type:'',
            typeName:'',
            typeList: [],
            total: null,
            query: {
                current: this.$route.query.current? Number(this.$route.query.current) : 1,
                pageSize: 8,
                newsType: this.$route.query.type?this.$route.query.type:'',
                model:2,
                lang:2
            },
            newsList: [],

            isShowType:false
        }
    },
    created() {
        this.getNewsType()
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        async getNewsType() {
            let res = await newsTypeList(
                {
                    model:2,
                    lang:2
                }
            )
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.typeList = res.data.records
            if(this.typeList.length > 0) {
                if(this.typeId) {
                    this.typeName = this.typeList.find(item => item.id == this.typeId).typeName
                } else {
                    this.typeId = this.typeList[0].id
                    this.query.newsType = this.typeList[0].id
                    this.typeName = this.typeList[0].typeName
                }
            }
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            this.loading = true // loading start
            let res = await newsList(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.total = res.data.total
            this.newsList = res.data.records
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 500);
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getNewsList()
            this.getScroll()
        },
        // 更改类型
        handleChangeType(id) {
            window.location.href = '/#/news_en?type=' + id
            this.typeId = id
            this.query.newsType = id
            this.query.current = 1
            this.getNewsList()
            this.getScroll()
        },
        // 跳转详情
        linkToDetails(item) {
            if(item.link) {
                window.open(item.link, '_blank');
            } else {
                this.$router.push({name: 'details_en', params: { name: 'news_en', type: this.typeId, id: item.id,current:this.query.current } })
            }
        },
        goIndex() {
            this.$router.push('/index_en')
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'-'+month+'-'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
        restoreScrollPosition() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition) {
                // 恢复滚动位置
                $('html, body').animate({scrollTop: scrollPosition}, 100)
                setTimeout(() => {
                    window.sessionStorage.removeItem('scrollPosition'); // 清除存储的滚动位置，防止重复使用
                }, 500);
            }
        },
        handleShowType() {
            this.isShowType = !this.isShowType
        }
    },
    beforeRouteLeave(to, from, next) {
        if(to.name == "details_en") {
            window.sessionStorage.setItem('scrollPosition', window.scrollY);
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 80px 0;
    .news_box {
        display: flex;
        .news_left {
            width: 288px;
            margin-right: 30px;
            position: relative;
            .news_left_box {
                padding: 24px 20px 20px 20px;
                background-color: #ffffff;
                .news_left_item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    padding: 0 20px 0 25px;
                    background-color: #F6F9FF;
                    margin-bottom: 10px;
                    height: 56px;
                    cursor: pointer;
                    position: relative;
                    .news_left_item_right {
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    .news_left_item_line {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0;
                        width: 6px;
                        height: 24px;
                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 6px;
                            height: 24px;
                        }
                    }
                }
                .news_left_item_active {
                    background-color: #0085D0;
                    color: #ffffff;
                }
                .news_left_item:last-child {
                    margin-bottom: 0;
                }
            }
            .news_left_line {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 4px;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                }
            }
        }
        .news_right {
            width: calc(100% - 288px - 30px);
            .news_right_top {
                margin-bottom: 10px;
            }
            .news_right_bottom {
                .news_right_bottom_box {
                    margin-bottom: 80px;
                    .news_right_bottom_item {
                        margin-bottom: 20px;
                        padding: 30px;
                        display: flex;
                        justify-content: space-between;
                        background-color: #ffffff;
                        cursor: pointer;
                        .news_right_bottom_item_left {
                            width: 248px;
                            height: 165px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            .none_img_box {
                                width: 248px;
                                height: 165px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                .none_img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }
                            }
                        }
                        .news_right_bottom_item_right {
                            width: calc(100% - 248px - 30px);
                            font-size: 16px;
                            color: #787878;
                            padding: 15px 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .news_right_bottom_item_right_top {
                                color: #000000;
                                font-size: 20px;
                                font-weight: bold;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .news_right_bottom_item_right_time {
                                margin-bottom: 5px;
                            }
                            .news_right_bottom_item_right_profile {
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                line-height: 1.8;
                            }
                        }
                    }
                    .news_right_bottom_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_bottom_item_right_top {
                            color: #0085D0;
                            text-decoration: underline;
                            text-underline-offset: 3px;
                        }
                    }
                    .news_right_bottom_item:last-child {
                        margin-bottom: 0;
                    }
                }
                .news_right_bottom_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ffffff;
                    min-height: 200px;
                    font-size: 16px;
                    margin-bottom: 60px;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        background-color: #f6f9ff;
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            flex-direction: column;
            .news_right {
                width: 100%;
                .news_right_bottom {
                    padding-top: 0.2rem;
                    .news_right_bottom_box {
                        margin-bottom: 0.6rem;
                        .news_right_bottom_item {
                            margin-bottom: 0.2rem;
                            padding: 0.2rem;
                            .news_right_bottom_item_left {
                                width: 2.3rem;
                                height: 1.6rem;
                                .none_img_box {
                                    width: 2.3rem;
                                    height: 1.6rem;
                                }
                            }
                            .news_right_bottom_item_right {
                                width: calc(100% - 2.3rem - 0.2rem);
                                font-size: 0.26rem;
                                padding: 0.08rem 0;
                                .news_right_bottom_item_right_top {
                                    font-size: 0.3rem;
                                }
                                .news_right_bottom_item_right_time {
                                    margin-bottom: 0;
                                }
                                .news_right_bottom_item_right_profile {
                                    line-height: 1.6;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 1;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                }
                            }
                        }
                        .news_right_bottom_item:hover {
                            box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                            .news_right_bottom_item_right_top {
                                color: #0085D0;
                                text-decoration: underline;
                                text-underline-offset: 3px;
                            }
                        }
                        .news_right_bottom_item:last-child {
                            margin-bottom: 0;
                        }
                    }
                    .news_right_bottom_none {
                        margin-top: 0.2rem;
                        min-height: 3rem;
                        font-size: 0.3rem;
                        margin-bottom: 0.6rem;
                    }
                }
            }
        }
    }
}
</style>